module.exports = __webpack_public_path__ + "5c114213/img/SOURCERY_poweredby_web.9819842b.png";